export default __webpack_public_path__ + "static/media/ArOut.e141997c.svg";